import React, { createContext, useContext, useState } from "react";

// Define the context structure
interface ScrollContextType {
    isScrollingDown: boolean;
    setIsScrollingDown: (value: boolean) => void;
}

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

// Hook for consuming the context
export const useScrollDirection = (): ScrollContextType => {
    const context = useContext(ScrollContext);
    if (!context) {
        throw new Error("useScrollDirection must be used within a ScrollProvider");
    }
    return context;
};

// Provider component
export const ScrollProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isScrollingDown, setIsScrollingDown] = useState(false);

    return (
        <ScrollContext.Provider value={{ isScrollingDown, setIsScrollingDown }}>
            {children}
        </ScrollContext.Provider>
    );
};
